import shiPalette from "../shiPalette";

const MuiFilledInput: object = {
  styleOverrides: {
    root: {
      "&:after": {
        color: shiPalette.text.primary,
      },
    },
    underline: {
      "&:after": {
        borderBottom: [[2, "solid", shiPalette.text.secondary]],
      },
    },
  },
};

export default MuiFilledInput;
